import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function MenuPrincipal({ onIdiomaSelect }) {
  

  const idiomas = ["Español", "Português", "English", "Italiano"];
  const [busqueda, setBusqueda] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (busqueda.trim() !== "") {
      navigate(`/buscar?query=${encodeURIComponent(busqueda)}`);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar cómic..."
          className="campo-busqueda"
        />
      </form>

      <nav>
        <ul className="menu">
          <li><Link to="/">Inicio</Link></li>
          <li><Link to="/tags" className="boton-menu">Tags</Link></li>
          <li><Link to="/autores" className="boton-menu">AUTOR</Link></li>

          <li className="dropdown">
            <button className="dropdown-btn">Lenguaje ▼</button>
            <ul className="dropdown-content">
              {idiomas.map((idioma) => (
<li
  key={idioma}
onClick={() =>
  onIdiomaSelect
    ? onIdiomaSelect(idioma)
    : navigate(`/buscar?idioma=${encodeURIComponent(idioma)}`)
}
>
  {idioma}
</li>              ))}
            </ul>
          </li>

          <li>
            <Link to="/busqueda-precisa" className="boton-preciso">
              Búsqueda precisa
            </Link>
          </li>
        </ul>
      </nav>
    </>
  );
}